import { action, observable } from 'mobx';

// Store
export class Modal {
  @observable public modal = false;

  @action public openModal = () => {
    this.modal = true;
  };

  @action public closeModal = () => {
    this.modal = false;
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/stores/Modal.ts